<script lang="ts" generics="ITEM">
    import type {SearchParams, ViewableSearch} from 'src/typings';
    import {exists} from 'shared/utils/custom-utils';
    import type {SearchManager} from '../search-manager/search-manager';
    import type {Observable} from 'rxjs';
    import KpSearchHeaderTitle from './KpSearchHeaderTitle.svelte';

    export let searchManager: SearchManager<ITEM>;

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();

</script>

{#if exists($lastSearch)}
    <div>
        <KpSearchHeaderTitle title={$lastSearch.title} subtitle={$lastSearch.subtitle}/>
    </div>
{/if}
